import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveExit32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMoveExit32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M18.736 13.588a1.2 1.2 0 0 0 1.2 1.2h7.756a1.2 1.2 0 0 0 0-2.4h-7.756a1.2 1.2 0 0 0-1.2 1.2m.213 4.813a1.2 1.2 0 0 0 1.2 1.2h5.275a1.2 1.2 0 0 0 0-2.4h-5.276a1.2 1.2 0 0 0-1.199 1.2M1.905 16.139a7.401 7.401 0 1 0 14.803 0 7.401 7.401 0 0 0-14.803 0m2.4 0a5.002 5.002 0 1 1 10.004.002 5.002 5.002 0 0 1-10.004-.002"
            />
        </svg>
    );
}
export default memo(IconMoveExit32);
